import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";

function EditBanner() {
  const params = useParams();
  const history = useHistory();
  const advertiseBannerID = params.id;

  const [advertiseBannerUser, setAdvertiseBannerUser] = useState();
  const [campaign, setCampaign] = useState();

  useEffect(() => {
    getAdvertiseBannerUser(advertiseBannerID);
  }, []);

  useEffect(() => {
    if (!advertiseBannerUser) {
      return;
    }
    getCampaign(advertiseBannerUser.adv_campaign_id);
  }, [advertiseBannerUser]);

  const getCampaign = async (campaignID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const campaign = await sendRequestGetCampaign(campaignID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!campaign) {
      return;
    }
    setCampaign(campaign);
  };

  const sendRequestGetCampaign = async (campaignID) => {
    const headersRequest = getHeaderForRequest();
    let campaign;
    try {
      campaign = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/manage/banner/simple/" +
          campaignID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return campaign.data.data;
  };

  const prefixLinkBannerAdvertise =
    process.env.REACT_APP_DOMAIN_API +
    "/" +
    process.env.REACT_APP_URL_ADVERTISE_FILES +
    "/banner";

  const getAdvertiseBannerUser = async (advertiseBannerID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const advertiseBannerUser = await sendRequestGetAdvertiseBannerUser(
      advertiseBannerID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setAdvertiseBannerUser(advertiseBannerUser);
  };

  const sendRequestGetAdvertiseBannerUser = async (advertiseBannerID) => {
    const headersRequest = getHeaderForRequest();
    let advertiseBannerUserInfo;
    try {
      advertiseBannerUserInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/banner/" +
          advertiseBannerID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return advertiseBannerUserInfo.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendForm = async (e) => {
    e.preventDefault();

    let messageText = document.querySelector("#message").value;

    if (messageText == "") {
      alert("لطفا دلیل رد شدن تبلیغ  را وارد کنید.");
      return;
    }

    let data = {
      confirm: "2",
      message: messageText,
    };

    if (await sendRequestEditAdvertiseBannerUser(advertiseBannerID, data)) {
      history.push("/advertise/manage/banner/all");
    }
  };

  const confirmAdvertiseBannerUser = async () => {
    const data = {
      confirm: "1",
    };
    if (await sendRequestEditAdvertiseBannerUser(advertiseBannerID, data)) {
      history.push("/advertise/manage/banner/all");
    }
  };

  const sendRequestEditAdvertiseBannerUser = async (
    advertiseBannerID,
    data
  ) => {
    const headersRequest = getHeaderForRequest();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/banner/" +
          advertiseBannerID,
        data,
        headersRequest
      );
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return true;
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
  };

  const generateAdvertise = () => {
    let tagConfirm;
    if (advertiseBannerUser.adv_confirm != null) {
      let classNameConfirmAdvertise = "";
      let textConfirmAdvertise = "";
      switch (advertiseBannerUser.adv_confirm) {
        case 0:
          classNameConfirmAdvertise = "warning";
          textConfirmAdvertise = "در حال بررسی";
          break;
        case 1:
          classNameConfirmAdvertise = "success";
          textConfirmAdvertise = "تایید شده";
          break;
        case 2:
          classNameConfirmAdvertise = "danger";
          textConfirmAdvertise = "رد شده";
          break;
      }

      tagConfirm = (
        <span className={`badge badge-${classNameConfirmAdvertise}`}>
          {textConfirmAdvertise}
        </span>
      );
    }

    let tagActive;
    if (advertiseBannerUser.adv_active != null) {
      let classNameStateAdvertise = advertiseBannerUser.adv_active
        ? "success"
        : "danger";
      let textStateAdvertise = advertiseBannerUser.adv_active
        ? "فعال"
        : "غیر فعال";
      tagActive = (
        <span className={`badge badge-${classNameStateAdvertise} `}>
          {textStateAdvertise}
        </span>
      );
    }

    let bannersTag = [];
    if (advertiseBannerUser.files != null) {
      const banners = advertiseBannerUser.files;

      Object.entries(banners).map((banner, index) => {
        const bannerSplit = banner[0].split("-");
        const width = bannerSplit[0];
        const height = bannerSplit[1];
        bannersTag.push(
          <div key={index} className="mb-2  ">
            <div className="text-center font-weight-bold bg-success" dir="ltr">
              <span> </span>
              <span className="px-2 text-dark">
                <span>{helperNumber.toPersianNum(width)}</span>
                <span className="px-2">*</span>
                <span>{helperNumber.toPersianNum(height)}</span>
              </span>
              <span></span>
            </div>
            <div className="position-relative">
              <a
                href={prefixLinkBannerAdvertise + "/" + banner[1].file_name}
                target="_blank"
              >
                <img
                  className="img-fluid"
                  src={prefixLinkBannerAdvertise + "/" + banner[1].file_name}
                />
              </a>
            </div>
          </div>
        );
      });
    }

    let bannersTagTemporary = [];
    if (
      advertiseBannerUser.temporary != null &&
      advertiseBannerUser.temporary != false
    ) {
      const bannersTemporary = advertiseBannerUser.temporary.advertise_files;
      bannersTagTemporary.push(
        <div className="py-2">
          <a
            className="btn btn-primary"
            target="blank"
            href={advertiseBannerUser.temporary.advertise_link}
          >
            <i className="fa fa-globe"></i>
          </a>
        </div>
      );
      Object.entries(bannersTemporary).map((banner, index) => {
        const bannerSplit = banner[0].split("-");
        const width = bannerSplit[0];
        const height = bannerSplit[1];
        bannersTagTemporary.push(
          <div key={index} className="mb-2  ">
            <div className="text-center font-weight-bold bg-success" dir="ltr">
              <span> </span>
              <span className="px-2 text-dark">
                <span>{helperNumber.toPersianNum(width)}</span>
                <span className="px-2">*</span>
                <span>{helperNumber.toPersianNum(height)}</span>
              </span>
              <span></span>
            </div>
            <div className="position-relative">
              <a
                href={prefixLinkBannerAdvertise + "/" + banner[1].file_name}
                target="_blank"
              >
                <img
                  className="img-fluid"
                  src={prefixLinkBannerAdvertise + "/" + banner[1].file_name}
                />
              </a>
            </div>
          </div>
        );
      });
    }

    return (
      <>
        <div className="table-responsive py-2">
          <table className="table table-hilite tbl-td-white-space table-hover m-0  ">
            <thead>
              <tr>
                <td
                  colspan="2"
                  class="text-center"
                  style={{ borderRadius: "25px 25px 0px 0px" }}
                >
                  <b>اطلاعات تبلیغ</b>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td> شماره تبلیغ </td>
                <td>{helperNumber.toPersianNum(advertiseBannerUser.adv_id)}</td>
              </tr>
              <tr>
                <td>شماره کاربری </td>
                <td>
                  {helperNumber.toPersianNum(advertiseBannerUser.adv_user_id)}

                  <span className="pr-1">
                    <Link
                      target="_blank"
                      to={`/user/show-info-user/${advertiseBannerUser.adv_user_id}`}
                    >
                      <span className="btn btn-primary">
                        نمایش اطلاعات کاربر
                      </span>
                    </Link>
                  </span>
                </td>
              </tr>
              <tr>
                <td> شماره کمپین </td>
                <td>
                  {helperNumber.toPersianNum(
                    advertiseBannerUser.adv_campaign_id
                  )}
                  <span className="pr-1">
                    <Link
                      target="_blank"
                      to={`/campaigns/manage/banner/simple/view/${advertiseBannerUser.adv_campaign_id}`}
                    >
                      <span className="btn btn-primary">
                        نمایش اطلاعات کمپین
                      </span>
                    </Link>
                  </span>
                </td>
              </tr>
              {campaign && (
                <tr>
                  <td> شماره گروه نمایش دهنده </td>
                  <td>
                    <span className="pl-2">
                      {helperNumber.toPersianNum(campaign.cam_category_id)}
                    </span>
                    <Link
                      target="_blank"
                      to={`/manage/category-user-site-publishers/${campaign.cam_category_id}`}
                    >
                      <span className="btn btn-primary">
                        نمایش گروه نمایش دهنده
                      </span>
                    </Link>
                  </td>
                </tr>
              )}

              <tr>
                <td>آدرس صفحه فرود</td>
                <td>
                  <a
                    className="btn btn-primary"
                    target="_blank"
                    href={advertiseBannerUser.link}
                  >
                    <i class="fa fa-globe"></i>
                  </a>
                </td>
              </tr>
              <tr>
                <td> وضعیت </td>
                <td>{tagActive}</td>
              </tr>
              <tr>
                <td> بررسی </td>
                <td>{tagConfirm}</td>
              </tr>
              <tr>
                <td> تاریخ ایجاد </td>
                <td>
                  {helperNumber.toPersianNum(
                    advertiseBannerUser.adv_created_at
                  )}
                </td>
              </tr>
              <tr>
                <td> تاریخ بروزرسانی </td>
                <td>
                  {helperNumber.toPersianNum(
                    advertiseBannerUser.adv_updated_at
                  )}
                </td>
              </tr>

              <tr>
                <td> تاریخ حذف </td>
                <td>
                  {" "}
                  {helperNumber.toPersianNum(advertiseBannerUser.adv__at)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          className="d-flex  flex-column align-items-center"
          id="img-upload-banners-container"
        >
          {bannersTag}
        </div>
        <hr />
        <h3 className="text-right">
          تبلیغ واردشده کاربر برای ویرایش در حالت کمپین فعال
        </h3>
        <div
          className="d-flex  flex-column align-items-center"
          id="img-upload-banners-container"
        >
          {bannersTagTemporary}
          <hr />
        </div>
        <hr />
        <div></div>
        <hr />
        <div>
          <form onSubmit={sendForm}>
            <div class="form-group">
              <label>دلیل رد شدن تبلیغ (این متن برای کاربر ارسال میشود)</label>
              <textarea class="form-control" id="message" rows="4" cols="50">
                {advertiseBannerUser.message}
              </textarea>
            </div>
            <div className="pb-3">
              <button className="btn btn-danger">رد تبلیغ</button>
            </div>
          </form>
          <hr />
          <div>
            <button
              onClick={confirmAdvertiseBannerUser}
              className="btn btn-success"
            >
              تایید تبلیغ
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اطلاعات تبلیغ بنری حذف شده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to="/advertise/manage/banner/all"
                  className="btn btn-primary"
                >
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {advertiseBannerUser && generateAdvertise()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditBanner;
